import { Component, inject, OnInit } from '@angular/core';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { NewsEditorConfigListService } from '../../../services/news/news-editor-config-list/news-editor-config-list.service';

@Component({
    selector: 'lib-news-editor-list',
    templateUrl: './news-editor-list.component.html',
    styleUrls: ['./news-editor-list.component.css'],
    standalone: false
})
export class NewsEditorListComponent implements OnInit {
  public newsEditorListConfigService = inject(NewsEditorConfigListService);
  protected gungModalService = inject(GungModalService);

  ngOnInit() {}

  openAddNewsModal(): void {
    this.gungModalService.openEditorNewsModal(null);
  }
}
